import type { InvestigationFinding, InvestigationLabels, RunStatus } from '@/frontend/features/Fde/investigations/types'

export const isActive = (status: RunStatus) => status === 'queued' || status === 'running'
export const isTextClipped = (visibleHeight: number, contentHeight: number) => visibleHeight > 0 && contentHeight > visibleHeight + 1
export const matchesInvestigationProject = (expected?: string | null, actual?: string | null) => Boolean(expected) && expected === actual
export const groupInvestigationFindings = (findings: InvestigationFinding[]) => ({
  retained: findings.filter((finding) => finding.status !== 'rejected'),
  rejected: findings.filter((finding) => finding.status === 'rejected'),
})
export const availableInvestigationSources = (selected: string[], sources: Array<{ id: string }>) => selected.filter((id) => sources.some((source) => source.id === id))

export const investigationUrl = (projectId: string, runId?: string, action?: string) => {
  const path = ['/dashboard/discovery/investigations', runId, action].filter(Boolean).join('/')
  return `${path}?${new URLSearchParams({ project_id: projectId })}`
}

export const investigationLabel = (copy: InvestigationLabels, group: string, value: string) => (
  copy[`${group}_${value}`] || copy[`unknown_${group}`]
)

export const investigationDate = (value: string | null) => {
  if (!value || Number.isNaN(Date.parse(value))) return '—'
  return new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'short', year: '2-digit', hour: '2-digit', minute: '2-digit' }).format(new Date(value))
}
